module.exports = __webpack_public_path__ + "components/intersport-discount-page/static/intersport-3@2-9667c731bec1326096039b44e3a652c1.jpg";